import icon from '@assets/img/icons/bookinginquiry-history.svg';
import { bookingsStrings } from '@data/bookings';
import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    mainTitle: bookingsStrings.bookingManagement,
    title: bookingsStrings.bookingInquiryHistory,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 1,
  breadcrumbs: [
    {
      to: '/utilities/Bookings/BookingInquiryHistory',
      children: strings.mainTitle,
    },
    {
      to: '/utilities/Bookings/BookingInquiryHistory',
      children: strings.title,
    },
  ],
};
